<template>
  <div class="mobile-navigation">
    <div class="mobile-navigation-left">
      <Button
        type="button"
        icon="pi pi-bars"
        class="p-button p-component p-button-inverted p-button-md p-as-start"
        @click="toggleDrawer"
        aria-haspopup="true"
        aria-controls="overlay_menu"
      />
    </div>
    <Drawer v-model:visible="showDrawer" blockScroll class="menu-drawer">
      <Menu :model="items" ref="menu">
        <template #item="{ item, props }">
          <router-link :to="item.to" v-slot="{ navigate }" custom v-if="!item.items && item.to">
            <a
              @click="handleMenuItemClick(navigate)"
              class="p-menu-item-link"
              v-bind="props.action"
              :title="item.label"
            >
              <icon :data="item.icon" :fill="false" class="p-menu-item-icon" />
              <span class="p-menu-item-label">{{ item.label }}</span>
            </a>
          </router-link>
          <a
            class="p-menu-item-link"
            v-bind="props.action"
            v-else-if="!item.items"
            :href="item.url"
            :title="item.label"
          >
            <icon :data="item.icon" :fill="false" class="p-menu-item-icon" />
            <span class="p-menu-item-label">{{ item.label }}</span>
          </a>
          <template v-else>
            <a
              class="p-menu-item-link"
              @click="toggleSublinks"
              v-bind="props.action"
              :title="item.label"
            >
              <icon :data="item.icon" :fill="false" class="p-menu-item-icon" />
              <span class="p-menu-item-label">{{ item.label }}</span>
              <icon
                data="@icon/arrow-down.svg"
                :fill="false"
                :dir="showSublinks ? 'down' : 'up'"
                width="1.5em"
                height="1.5em"
                class="arrow-down text-color-secondary p-ml-auto"
              />
            </a>
            <template v-if="showSublinks">
              <router-link
                v-for="subLink in item.items"
                :to="subLink.to"
                :key="subLink.name"
                v-slot="{ navigate }"
              >
                <a
                  @click="handleMenuItemClick(navigate)"
                  class="p-menu-item-link"
                  v-bind="props.action"
                >
                  <span class="p-menu-item-label p-ml-5">{{ subLink.label }}</span>
                </a>
              </router-link>
            </template>
          </template>
        </template>
      </Menu>
    </Drawer>
    <div class="mobile-navigation-right">
      <ProfileMenu :user="user" collapsed :showLogout="false" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Menu from "primevue/menu";
import Button from "primevue/button";
import Drawer from 'primevue/drawer';
import ProfileMenu from "@/components/elements/ProfileMenu";

export default defineComponent({
  name: "MobileNavigation",
  components: { Button, ProfileMenu, Menu, Drawer },
  props: {
    user: Object as User,
    items: Array,
  },
  data() {
    return {
      menu: null,
      showDrawer: false,
      showSublinks: false,
    };
  },
  methods: {
    toggleSublinks() {
      this.showSublinks = !this.showSublinks;
    },
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
    handleMenuItemClick(navigate) {
      this.showDrawer = false;
      navigate();
    },
  },
});
</script>
<style lang="scss">
.mobile-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--element-bg-secondary);
  padding: var(--grid-gutter) 2rem;
  color: white;
  z-index: 1000;
  .profile-menu {
    box-shadow: none;
    width: max-content;
    .p-menu-list {
      .p-menu-item-link {
        padding: 0.75rem;
      }
    }
    .p-menu {
      width: max-content;
      left: auto !important;
      right: 0;
    }
    .profile-button {
      padding: 0;
    }
    .avatar {
      font-size: 1rem;
    }
  }
  .p-button.p-button-md {
    .p-button-icon {
      font-size: 1.5rem;
    }
  }
}
.menu-drawer {
  width: 80vw;
  background: var(--element-bg-secondary) !important;
  padding: 1.25rem;
  .p-drawer-header {
    margin-bottom: 1.5rem;
  }
  .p-menu {
    border: none;
    background: transparent;
    .p-menu-item-link {
      padding: 1.5rem;
    }
    .p-menu-submenu-label {
      background: transparent;
    }
  }
}
</style>
